import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getJobDetails, GetBrowseProjects } from '../../Apis/index';

export const BrowseProjects = createAsyncThunk('BrowseProjects', async ({formData, token}, { rejectWithValue }) => {



    try {
        const response = await GetBrowseProjects(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const JobDetailss = createAsyncThunk('jobdetails', async ({ id, token }, { rejectWithValue }) => {

    try {
        const response = await getJobDetails({ id, token });
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const jobdetailsSlice = createSlice({
    name: 'jobdetails',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearjobdetailsStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(JobDetailss.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(JobDetailss.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(JobDetailss.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(BrowseProjects.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(BrowseProjects.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(BrowseProjects.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearjobdetailsStatus } = jobdetailsSlice.actions;
export default jobdetailsSlice.reducer;

